import Item from "src/core/checkout/models/item";
import {findRelation, populateRelations} from "../../api/utils";
import get from "lodash/get";
import autoBind from "auto-bind";
import {deepClone} from "src/core/common/utils";
import Product from "./product";

class TymberItem extends Item {
  constructor(itemObject, pricesObject = {}) {
    super(itemObject);
    this.pricesObject = pricesObject;
    Object.freeze(pricesObject);
    autoBind(this);
  }

  getId() {
    return this.itemObject ? this.itemObject.data.id : "";
  }

  getThumbnail() {
    const product = this.getProduct();
    return product.getMainImage();
  }

  getDescription() {
    const product = this.getProduct();
    return product.getDescription();
  }

  getName() {
    const product = this.getProduct();
    return product.getName();
  }

  getBrandName() {
    const product = this.getProduct();
    return product.getBrandName();
  }

  getQuantity() {
    return this.itemObject ? this.itemObject.data.attributes.quantity : 0;
  }

  getPrices() {
    const zeroTotal = {amount: 0, currency: "usd"};
    return {
      totalPrice: get(this.pricesObject, "attributes.final_price", zeroTotal),
      basePrice: get(this.pricesObject, "attributes.base_price", zeroTotal),
    };
  }
  hasPrices() {
    return Boolean(get(this.pricesObject, "attributes"));
  }

  hasDiscount() {
    const {basePrice, totalPrice} = this.getPrices();
    return basePrice && totalPrice && basePrice.amount !== totalPrice.amount;
  }

  setQuantity(quantity) {
    const newItemObject = deepClone(this.itemObject);
    newItemObject.data.attributes.quantity = quantity;
    return new TymberItem(newItemObject);
  }

  getProduct = () => {
    const productObj = findRelation(
      this.itemObject.included,
      this.itemObject.data.relationships.product.data
    );
    return new Product(populateRelations(productObj, this.itemObject.included));
  };

  hasWeightPrices() {
    return this.getProduct().hasWeightPrices();
  }
  getWeightPrice() {
    const weightKey = get(this.itemObject, "data.attributes.weight_key");
    if (!this.getProduct().hasWeightPrices() || !weightKey) return null;
    const productWeightPrices = this.getProduct().getWeightPrices();

    return productWeightPrices.find(wp => wp.weightKey === weightKey);
  }

  setWeightKey(weightPrice) {
    const newItemObject = deepClone(this.itemObject);
    newItemObject.data.attributes.weight_key = weightPrice.weightKey;
    return new TymberItem(newItemObject).setQuantity(weightPrice.quantity || 1);
  }
  getWeightKey() {
    return get(this.itemObject, "data.attributes.weight_key");
  }

  getProductId() {
    const product = this.getProduct();
    return product.getId();
  }

  getProductSku() {
    const product = this.getProduct();
    return product.getSku();
  }

  getProductCategories() {
    return [];
  }

  getProductUnitPrice() {
    const product = this.getProduct();
    return product.getUnitPrice();
  }

  getSavings() {
    return this.getProduct().getSavings(this.getQuantity());
  }
  isSaving() {
    return this.getProduct().isSaving(this.getQuantity());
  }
  clone() {
    return new TymberItem(deepClone(this.itemObject), deepClone(this.pricesObject));
  }
}

export default TymberItem;
